export { useBootstrap, useEmbedBootstrap } from "./useBootstrap";
export { useEmbedMode } from "./useEmbedMode";
export { useFeatureFlags, FEATURE_FLAGS } from "./useFeatureFlags";
import { useReactiveVar } from "@apollo/client";
import { initVar } from "../vars";
export const useInitState = () => useReactiveVar(initVar);
